<template>
  <ValidationObserver ref="observer">
    <form
      class="card-custom-form"
      ref="edit_req_spare_part_form"
      @submit.prevent="addReqSparePart"
    >
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="pool" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Request for Eshed</label>
                  <md-select v-model="spare_part_request_warehouse_id" required>
                    <md-option
                      v-for="option in options_warehouse_list"
                      :key="option.value"
                      :value="option.id"
                      :is-selected="true"
                    >
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.dp_amount_type"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
            <!-- <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Request to Werehouse</label>
                  <md-select
                    v-model="spare_part_request_warehouse_to_id"
                    required
                  >
                    <md-option
                      v-for="option in options_warehouse_list"
                      :key="option.value"
                      :value="option.id"
                    >
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.dp_amount_type"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div> -->
          </div>

          <div class="md-layout mb-2">
            <div class="md-layout-item md-small-size-100">
              <md-field>
                <label class="label">Remark</label>
                <md-input v-model="spare_part_request_remark" />
              </md-field>
            </div>
          </div>

          <div class="md-layout">
            <div
              class="columns columns-custom"
              v-for="(item, index) in items"
              :key="index"
            >
              <div
                class="header"
                style="font-weight:bold; text-align:center; margin-bottom:20px; font-size:20px;"
              >
                <label class="label"
                  >{{
                    item.spare_part_name == null ? "New" : index + 1
                  }}
                  Item</label
                >
              </div>
              <div class="md-layout">
                <input
                  v-model="item.spare_part_request_item_master_id"
                  :readonly="true"
                  type="hidden"
                />
                <div
                  class="md-layout-item md-size-30 md-small-size-100"
                  style="margin-top: 2px;"
                >
                  <div class="md-layout">
                    <div class="md-layout-item">
                      <validation-provider
                        :rules="
                          index + 1 === items.length && items.length !== 1
                            ? null
                            : 'item'
                        "
                        ref="spare_part"
                        v-slot="{ errors }"
                      >
                        <md-field class="md-invalid">
                          <label class="label">Spare part Name</label>
                          <md-input v-model="item.spare_part_name" disabled />

                          <validation-error
                            :errors="apiValidationErrors.spare_part_name"
                          />
                          <span class="md-error">{{ errors[0] }}</span>
                        </md-field>
                      </validation-provider>
                    </div>
                    <div class="md-layout-item md-size-5">
                      <md-button
                        :disabled="items.length - 1 === index ? false : true"
                        :class="[
                          items.length - 1 === index
                            ? 'md-icon-button md-round md-dense md-info'
                            : 'md-icon-button md-round md-dense',
                        ]"
                        v-on:click="modalOpenListSparePart(index)"
                      >
                        <md-icon>search</md-icon>
                      </md-button>
                    </div>
                  </div>
                </div>

                <div
                  class="md-layout-item md-size-15 md-small-size-100"
                  style="margin-left:40px;"
                >
                  <md-field>
                    <label class="label">Stock</label>
                    <md-input
                      v-model="item.spare_part_stock"
                      :readonly="true"
                      disabled
                    />
                  </md-field>
                </div>

                <div class="md-layout-item md-size-15 md-small-size-100">
                  <validation-provider
                    :rules="
                      index + 1 === items.length && items.length !== 1
                        ? null
                        : 'total_request'
                    "
                    v-slot="{ errors }"
                  >
                    <md-field class="md-invalid">
                      <label class="label">Total Requested</label>
                      <md-input
                        :disabled="item.spare_part_name == null ? true : false"
                        v-on:keypress="NumbersOnly"
                        v-model="
                          spare_part_request_item[index]
                            .spare_part_request_item_qty
                        "
                      />
                      <validation-error
                        :errors="apiValidationErrors.total_request"
                      />
                      <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                  </validation-provider>
                </div>
                <div class="md-layout-item md-small-size-100">
                  <md-field>
                    <label class="label">Remark</label>
                    <md-input
                      :disabled="item.spare_part_name == null ? true : false"
                      v-model="
                        spare_part_request_item[index]
                          .spare_part_request_item_remark
                      "
                    />
                  </md-field>
                </div>
                <md-card-actions style="border:none;">
                  <md-button
                    :disabled="
                      items.length == 1 || index + 1 == items.length
                        ? true
                        : false
                    "
                    class="md-button-icon md-danger md-dense"
                    @click="deleteColumn(index)"
                  >
                    delete
                  </md-button>
                </md-card-actions>
              </div>
            </div>
          </div>
        </md-card-content>
        <modal ref="modalSparePart" class="coba">
          <template v-slot:body>
            <list-spare-part :data_id="$refs.modalSparePart.data" />
          </template>
        </modal>

        <md-card-actions>
          <md-button class="md-info md-dense" @click="addConfirmation">
            Submit
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>

<script>
import { Modal } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";
import ListSparePart from "@/pages/Dashboard/Workshop/SparePartRequest/modal/ListSparePart.vue";

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi
extend("pool", {
  ...required,
  message: "Eshed field is required",
});
extend("item", {
  ...required,
  message: "Field is required",
});
extend("total_request", {
  ...required,
  message: "Field is required",
});

export default {
  name: "edit-request-spm",

  props: {
    data: Object,
    data_id: null,
  },

  components: {
    ValidationError,
    ValidationObserver,
    Modal,
    "list-spare-part": ListSparePart,
  },

  mixins: [formMixin],

  data: () => ({
    // data field column items
    items: [],
    // data yang akan dikirim ke server
    spare_part_request_warehouse_id: null,
    spare_part_request_remark: null,
    spare_part_request_item: [
      {
        spare_part_request_item_request_id: null,
        spare_part_request_item_master_id: null,
        spare_part_request_item_qty: null,
        spare_part_request_item_remark: null,
      },
    ],
    get_spare_part_req: null,
    options_warehouse_list: [],
  }),

  async created() {
    this.getWarehouse();
    // this.getList();
    this.getItemReq();
  },

  methods: {
    async getWarehouse() {
      var user = await this.$store.getters["profile/me"];
      if (!user.pool) {
        await this.$store.dispatch("workshop_warehouse/list");
        this.options_warehouse_list = await this.$store.getters[
          "workshop_warehouse/list"
        ];
        this.options_warehouse_list.splice(0, 1);
      } else {
        if (user.pool.warehouse.length > 1) {
          this.options_warehouse_list = user.pool.warehouse;
        } else {
          this.warehouse = user.pool.warehouse[0].id;
        }
      }
    },

    async getItemReq() {
      await this.$store.dispatch(
        "workshop_spare_part_request/get",
        this.data_id.id
      );
      this.get_spare_part_req = await this.$store.getters[
        "workshop_spare_part_request/spare_part_request"
      ];

      this.spare_part_request_item = this.get_spare_part_req.spare_part_request_item;
      this.spare_part_request_warehouse_id = this.get_spare_part_req.spare_part_request_warehouse.id;
      this.spare_part_request_remark = this.get_spare_part_req.spare_part_request_remark;

      // menambahkan 1 data array di akhir
      this.spare_part_request_item.push({});

      // looping and insert
      this.spare_part_request_item.forEach(async (value, index) => {
        // tidak mengambil data null pada array terkhir
        if (index !== this.spare_part_request_item.length - 1) {
          let query = {
            filter: {
              warehouse: this.spare_part_request_warehouse_id,
              id: value.spare_part_request_item_master_id,
            },
          };
          await this.$store.dispatch("workshop_spare_part_master/list", query);
          let dataStock = await this.$store.getters[
            "workshop_spare_part_master/list"
          ];

          // set array berdasarkan data yang ada di item
          await this.$set(this.items, index, {
            id: value.id,
            spare_part_request_item_master_id:
              value.spare_part_request_item_master_id,
            spare_part_name: value.spare_part.spare_part_master_name,
            spare_part_stock: dataStock[0].spare_part_master_stock,
            spare_part_request_item_qty: value.spare_part_request_item_qty,
            spare_part_request_item_remark:
              value.spare_part_request_item_remark,
          });
        } else {
          // mengambil data terakhir array
          // set array berdasarkan data yang ada di item
          await this.$set(this.items, index, {
            id: null,
            spare_part_request_item_master_id: null,
            spare_part_name: null,
            spare_part_stock: null,
            spare_part_request_item_qty: null,
            spare_part_request_item_remark: null,
          });
        }
      });
    },

    modalOpenListSparePart(index) {
      this.$refs.modalSparePart.openModal({ index: index });
    },

    modalCloseListSparePart(data, index) {
      // fungsi mencari data yang sama
      let logic = this.spare_part_request_item.find(
        ({ spare_part_request_item_master_id }) =>
          spare_part_request_item_master_id == data.id
      );
      // data id tidak boleh sama
      if (logic === undefined) {
        if (data.id) {
          // untuk insert setiap selesain mengclik Spart Part Name dari card LIST Spart Part
          this.items.splice(this.items.length - 1, 0, {
            spare_part_request_item_master_id: data.id,
            spare_part_name: data.spare_part_master_name,
            spare_part_stock: data.spare_part_master_stock,
          });
          // untuk insert data yang akan di kirim ke server
          this.spare_part_request_item.splice(
            this.spare_part_request_item.length - 1,
            0,
            {
              spare_part_request_item_master_id: data.id,
              spare_part_request_item_qty: null,
              spare_part_request_item_remark: null,
            }
          );
          this.$refs.modalSparePart.closeModal();
        }
      } else {
        if (data.id) {
          this.$refs.modalSparePart.closeModal();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data.spare_part_master_name + " Already!",
          });
        }
      }
    },

    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Save it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          // sebelum dikirim ke server array trakhir akan di hapus karna nilai array terakhir tidak digunakan
          this.items.splice(this.items.length - 1, 1);
          this.spare_part_request_item.splice(
            this.spare_part_request_item.length - 1,
            1
          );
          this.addReqSparePart();
        }
      });
    },

    // fungsi add data
    async addReqSparePart() {
      const data = {
        type: "workshop_spare_part_requests",
        id: this.get_spare_part_req.id,
        spare_part_request_warehouse_id: this.spare_part_request_warehouse_id,
        spare_part_request_remark: this.spare_part_request_remark,
        spare_part_request_item: this.spare_part_request_item,
      };
      try {
        await this.$store.dispatch("workshop_spare_part_request/update", data);
        // console.log(data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        this.$parent.$parent.modalCloseEditRequest();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }
    },

    deleteColumn(index) {
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be Delete!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Delete it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.items.splice(index, 1);
          this.spare_part_request_item.splice(index, 1);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.coba {
  width: 800px !important;
  margin: 50px auto !important;
  // top: auto !important;
  // bottom: auto !important;
  z-index: 9999 !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
    z-index: 9999 !important;
  }
}

.card-custom-form {
  padding: 0px 15px;
}

.columns-custom {
  padding-bottom: 20px;
}

.mb-2 {
  margin-bottom: 2rem !important;
}

// hanya dikondisi screen max width tersebut
@media only screen and (max-width: 1140px) {
  .card-custom-form {
    padding: 0px 10px;
  }
}
</style>
